import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthService } from "../providers/auth.provider";
import { CONST } from "../providers/const";

@Injectable()
export class ProfileRouteLogged implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        let showProfileCompleted = localStorage.getItem(CONST.LOCALSTORAGE.showProfileCompleted)
        if (+step == CONST.PROFILE_STEP.complete && !showProfileCompleted) {
            return true;
        } else if ((+step == CONST.PROFILE_STEP.complete && showProfileCompleted)) {
            localStorage.removeItem(CONST.LOCALSTORAGE.showProfileCompleted);
            this.router.navigate(['/portal/profile/profile-completed'], { replaceUrl: true });
        } else {
            this.router.navigate(['/portal/profile/complete-profile'], { replaceUrl: true });
            return false;
        }
    }
}



@Injectable()
export class ProfilePhotoRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        if (role == CONST.ROLES.club_staff && +step == CONST.PROFILE_STEP.CLUB_STAFF.profilePhoto) {
            return true;
        } else if (role == CONST.ROLES.parent && +step == CONST.PROFILE_STEP.PARENT.profilePhoto) {
            return true;
        } else if (role == CONST.ROLES.athlete && +step == CONST.PROFILE_STEP.ATHLETE.profilePhoto) {
            return true;
        } else if (role == CONST.ROLES.scout && +step == CONST.PROFILE_STEP.SCOUT.profilePhoto) {
            return true;
        } else if (role == CONST.ROLES.stf_staff && +step == CONST.PROFILE_STEP.STF.profilePhoto) {
            return true;
        }
        else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}


@Injectable()
export class ProfileIdDocumentRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        if (role == CONST.ROLES.club_staff && +step == CONST.PROFILE_STEP.CLUB_STAFF.idDocumentPhoto) {
            return true;
        } else if (role == CONST.ROLES.parent && +step == CONST.PROFILE_STEP.PARENT.idDocumentPhoto) {
            return true;
        } else if (role == CONST.ROLES.athlete && +step == CONST.PROFILE_STEP.ATHLETE.idDocumentPhoto) {
            return true;
        } else if (role == CONST.ROLES.scout && +step == CONST.PROFILE_STEP.SCOUT.idDocumentPhoto) {
            return true;
        } else if (role == CONST.ROLES.stf_staff && +step == CONST.PROFILE_STEP.STF.idDocumentPhoto) {
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}


@Injectable()
export class ProfileDescribeYourselfRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        if (role == CONST.ROLES.club_staff && +step == CONST.PROFILE_STEP.CLUB_STAFF.describeYourself) {
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}

@Injectable()
export class ProfileClubInfoRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        if (role == CONST.ROLES.club_staff && +step == CONST.PROFILE_STEP.CLUB_STAFF.clubData) {
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}


@Injectable()
export class ProfileClubLogoRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        if (role == CONST.ROLES.club_staff && +step == CONST.PROFILE_STEP.CLUB_STAFF.clubLogo) {
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}

@Injectable()
export class ProfileCreateTeamRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;
        let role = user.role;

        if (role == CONST.ROLES.club_staff && +step == CONST.PROFILE_STEP.CLUB_STAFF.createTeam) {
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}




@Injectable()
export class ProfileCompletedRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;

        let showProfileCompleted = localStorage.getItem(CONST.LOCALSTORAGE.showProfileCompleted);
        if (+step == CONST.PROFILE_STEP.complete && showProfileCompleted) {
            localStorage.removeItem(CONST.LOCALSTORAGE.showProfileCompleted)
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }

        return true
    }
}




@Injectable()
export class CompleteProfileRoute implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;

        if (step != 0) {
            return true;
        } else {
            this.router.navigate(['/portal/profile'], { replaceUrl: true });
            return false;
        }
    }
}

@Injectable()
export class RolesManagementRouterLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null
        let step = user.step;
        if (role && role != CONST.ROLES.admin && role != CONST.ROLES.stf_staff) {
            if (+step == CONST.PROFILE_STEP.complete) {
                return true;
            } else {
                this.router.navigate(['/portal/profile']);
                return false;
            }
        } else {
            this.router.navigate(['/portal']);
            return false;
        }
    }
}




